export enum BookingQueuesEnum {
    CancelForAnyReasonInsurance = "CFAR"
}